import { intercomSendData, intercomTrackEvent } from './intercomHelper'

export default function sendAddressToIntercom(location, deliveryZoneName) {
  // Update user or visitor search data on Intercom
  const searchedZone = {
    'Last searched city': location.city,
    'Last searched address': location.street_name,
    'Last searched delivery zone': deliveryZoneName
  };

  intercomSendData(searchedZone);
  intercomTrackEvent('covered_address_search', searchedZone);
}
